export const ACTIVATE = "activate"
export const DEACTIVATE = "deactivate"
export const DELETE = "delete"
export const UNDELETE = "undelete"
export const VIEW = "view"
export const SEARCH = "search"
export const UPDATE = "update"
export const REGISTRED = "registred"
export const CREATE = "create"
export const VIEW_UPDATE = "view_update"
export const CLOSE = "close"
export const LIST = "list"
export const REJECT = "reject"
export const ACCEPT = "accept"
export const UPDATE_PAST = "update_past"
export const VIEW_MENU="view_menu"
export const VIEW_ABSENT_ANTIRABIQUE="view_absent_antirabique"
export const PROTOCOL_ANTIRABIQUE="update_protocol_antirabique"
export const COLSE_PROTOCOL_ANTIRABIQUE="close_protocol_antirabique"
export const DELETE_PROTOCOL_ANTIRABIQUE="delete_protocol_antirabique"
export const CREATE_NEXT = "create_next"






